/**
 * @description Componente para buscar tutor pelo CPF no fluxo veterinário
 * @module VetTutorSearch
 */

import { useState } from "react";
import { Stack, Typography, Button } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { FormTextInput } from "../../../../components/form";
import { RequiredField } from "../../../schedule/components/RequiredField";
import { useRegex } from "../../../../utils/useRegex";
import { useFormatter } from "../../../../utils/useFormatter";

interface IProps {
  control: any;
  cpfValue: string;
  onSearchTutor: () => void;
  loading?: boolean;
}

/**
 * Componente para buscar tutor pelo CPF
 * Exibe campo de CPF e botão de busca
 */
export function VetTutorSearch({
  control,
  cpfValue,
  onSearchTutor,
  loading = false,
}: IProps) {
  return (
    <Stack spacing={2}>
      {/* Título e descrição */}
      <Stack>
        <Typography variant="h6" fontWeight="600" color="neutral600.main">
          Tutor <RequiredField />
        </Typography>
        <Typography variant="body1">
          Digite o CPF do tutor para localizar os pets cadastrados
        </Typography>
      </Stack>

      {/* Campo de CPF e botão de busca */}
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <FormTextInput
          label="CPF do Tutor"
          name="cpf"
          control={control}
          required={true}
          pattern={useRegex.cpf}
          mask={useFormatter.formatCPF}
          maxLength={14}
          autoFocus
        />
      </Stack>
    </Stack>
  );
}
